export default __webpack_public_path__ + "static/media/contact_1024_90.5162eb78.webp";